<template>
  <PageContainer class="space-y-4 mt-4 lg:space-y-6 lg:mt-6">
    <div class="flex flex-col space-y-4 overflow-auto pb-4">
      <h1
        class="text-2xl font-medium flex items-center truncate space-x-2 mx-auto py-6 sm:py-12"
      >
        <IconBookmark :size="32" :stroke-width="2" />
        <span>My Library</span>
      </h1>
      <Tabs class="mx-auto !mt-0" v-model="current" :tabs="paths" />
    </div>
    <ClientOnly>
      <NamiRequireAuth>
        <NuxtPage />
      </NamiRequireAuth>
    </ClientOnly>
  </PageContainer>
</template>

<script setup lang="ts">
import { IconBookmark } from "@tabler/icons-vue";

const nuxtApp = useNuxtApp();
const { locale, t: translate } = useI18n();
const mappedLocale = computed(() => reverseLocaleMap(locale.value));

const { current, paths } = useSubpaths(
  computed(() => ({
    default: "/status",
    rootPath: `/${mappedLocale.value}/library`,
    paths: [
      // {name: translate("site.library.tab.notifications"), value: "notifications"},
      { name: translate("site.library.tab.watched"), value: "status" },
      { name: translate("site.library.tab.lists"), value: "lists" },
      { name: translate("site.library.tabHistory"), value: "history" },
    ],
  })),
);
</script>
